import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FormService } from './form.service';
import { Global } from '../global';
import { sanitizeIdentifier } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  sessionID;
  constructor(private _http: HttpClient, private formService: FormService, private global: Global) {
    
    let access_token = localStorage.getItem('access_token');   
    this.getToken().subscribe(resp => {
      //ZSS 090821: set session every refresh of application
      this.sessionID = resp['session_id'];
      //ZSS 090521: first time user will get this; or user on new device or incognito
      //ZSS 090521: every other time, the user will pass token until it expires, and the API will send back a new one when token has expired
      if(access_token == null || resp['access_token'] != access_token){        
        //console.log('token not matching');
        localStorage.clear();
        localStorage.setItem('access_token', resp['access_token']);
      }
    });
  }

  post(url: string, model: any): Observable<any> {
    let body = model;
    let org = { organization: this.global.orgID };
    let sessionID = { session_id: this.sessionID }
    body = {...body,...sessionID,...org};
    // console.log('new body', body)
    let access_token = localStorage.getItem('access_token');

    return this._http.post(url, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Authorization', 'bearer ' + access_token)
    }).pipe(catchError(err => this.handleError(err)))
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json || '';
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(error.json().error || 'Server error');
  }

  getPDF(url, body) {
    let organization = this.global.orgID;
    let access_token = localStorage.getItem('access_token');

    body.access_token = access_token;
    body.organization = organization;
    body.session_id = this.sessionID;

    return this._http.post(url, body, {
      responseType: 'blob',
      headers: new HttpHeaders().set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Authorization', 'bearer ' + access_token)
    }).pipe(catchError(err => this.handleError(err)))
  }

  private getToken() {
    //need to always pass token, even when getting another token. We need to check if the old one has/is expired
    let access_token = localStorage.getItem('access_token');
    // console.log('token on gettoken', access_token);
    return this._http.post(Global.BASE_URL + Global.GET_TOKEN, { organization: this.global.orgID, session_id: this.sessionID }, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Authorization', 'bearer ' + access_token)
    }).pipe(catchError(err => this.handleError(err)))
  }
}
